/**
 * This is a random uid generator similar to the one used in
 * RC-Upload component which Ant uses internally for its file upload.
 */ export const uid = (prefix = 'uid')=>{
    const now = +new Date();
    return [
        prefix,
        now
    ].join('-');
};
export const floatUid = ()=>Math.floor(Math.random() * Date.now());
export const floatUidString = ()=>floatUid().toString();
export const negativeUid = ()=>-1 * floatUid();
